import UserPictureProfile from 'Store/class/user_picture_profile'
import debug from 'debug'
import API from '@/api'
import events from 'Store/events'

const dbg = debug('store:userPictureProfiles:')

const actions = {

  getMetadata ({ commit }) {
    dbg('loading profile pictures metadata')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    API.userPictureProfilesMetadata()
      .then(response => {
        commit('ADD_META', response.data)
        commit('LOADED')
        this.dispatch('currentUser/refreshPictureProfile')
        this.dispatch('userPictureProfiles/refreshPictures')
      })
      .catch(err => {
        dbg(err)
        const msg = API.getException(err) || 'Failed to get user picture profiles'
        events.pubError(msg)
      })
  },

  upload ({ commit }, file) {
    dbg('uploading a new profile picture')
    API.userPictureProfilesUpload(file).then(resp => {
      this.dispatch('userPictureProfiles/getMetadata')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to upload new user picture profile')
    })
  },

  switch ({ commit }, pictureType) {
    dbg('Switching profile picture')
    API.switchUserPictureProfile(pictureType).then(resp => {
      this.dispatch('userPictureProfiles/getMetadata')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to switch user picture profile')
    })
  },

  delete ({ commit }, id) {
    dbg('Deleting profile picture')
    API.userPictureProfilesDelete(id).then(resp => {
      this.dispatch('userPictureProfiles/getMetadata')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to delete user picture profile')
    })
  },

  refreshPictures ({ commit }) {
    if (state.metadata !== []) {
      state.metadata.forEach((pictureData, index) => {
        const url = new URL(pictureData.url)
        url.searchParams.set('rand', Date.now())
        commit('REFRESH_PIC', { url, index })
      })
    }
  }
}

const mutations = {
  ADD_META (state, data) {
    const pictures = []
    data.forEach(picture => {
      pictures.push(new UserPictureProfile(picture))
    })
    state.metadata = pictures
  },

  REFRESH_PIC (state, { url, index }) {
    state.metadata[index].url = url.href
  },

  LOADED (state) {
    state.loaded = true
  }
}

const state = {
  metadata: [],
  loaded: false
}

const getters = {
  metadata: state => state.metadata,
  loaded: state => state.loaded
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
